// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__marginBottom___lKRfS {
  margin-bottom: 20px;
}
.styles__inline___pjfFK {
  display: flex;
  font-size: 14px;
  align-items: center;
}
.styles__row___qNIJU {
  width: 100%;
  display: flex;
  flex-direction: column;
}
@media (min-width: 991px) {
  .styles__row___qNIJU {
    flex-direction: row;
    align-items: center;
  }
}
.styles__topItem___FxQTR {
  padding-top: 10px;
  min-height: 44px;
}
.styles__testRatings___nue5C {
  min-height: 13px;
}
.styles__flexIt___sd794 {
  display: flex;
  align-items: center;
}
.styles__img___CDyjJ {
  border: none;
  margin-left: -5px;
  width: 120px;
  vertical-align: top;
}
.styles__productThumbnail___VvdzD {
  width: 100%;
  margin: 0 auto;
  padding: 10px 0;
  text-align: center;
  cursor: pointer;
  position: relative;
  display: flex;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.05);
}
.styles__productThumbnail___VvdzD > div {
  margin: 0 auto;
}
.styles__productBadge___lgPvN {
  position: absolute;
  bottom: 10px;
  right: calc(50% - 60px);
  z-index: 1;
}
.styles__product___sjClU {
  padding-right: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  background: #fff;
  display: flex;
  flex-direction: column;
}
@media (min-width: 991px) {
  .styles__product___sjClU {
    height: 180px;
  }
}
@media (max-width: 991px) {
  .styles__product___sjClU {
    flex-direction: column;
    padding-right: 0;
    padding-bottom: 0px;
  }
}
.styles__titleColumn___QCNZ4 {
  display: flex;
  align-items: center;
}
@media (max-width: 991px) {
  .styles__titleColumn___QCNZ4 {
    border-bottom: 1px solid #ccc;
    justify-content: center;
  }
}
.styles__titleWidth___d6pM_ {
  max-width: calc(100% - 120px);
}
.styles__productTitle___xjHWv {
  font-weight: 400;
  font-size: 18px;
  display: block;
  text-overflow: ellipsis;
  text-decoration: underline;
}
.styles__smFull___EyPmU {
  width: auto;
}
@media (max-width: 991px) {
  .styles__smFull___EyPmU {
    min-width: 270px;
    width: 100%;
    height: 48px;
  }
}
.styles__buttonGroup___TU1jA {
}
@media (min-width: 992px) {
  .styles__buttonGroup___TU1jA {
    margin-top: 20px;
  }
}
@media (max-width: 991px) {
  .styles__colFullSize___AvGIg {
    padding: 0 !important;
  }
}
.styles__commentInput___kfSL2 {
  border: none !important;
  box-shadow: none !important;
}
.styles__quantityInCartSm___Yq6Ug {
  text-align: right;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
}
@media (min-width: 992px) {
  .styles__quantityInCartSm___Yq6Ug {
    display: none;
  }
}
.styles__quantityInCartMd___W6c9z {
  text-align: right;
  width: 100%;
}
@media (max-width: 991px) {
  .styles__quantityInCartMd___W6c9z {
    display: none;
  }
}
.styles__priceInfo___ptvk_ {
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
}
.styles__priceInfo___ptvk_ .styles__price___DDDaX {
  font-size: 20px;
  font-weight: bold;
}
.styles__priceInfo___ptvk_ .styles__pricePcs___UakAO {
  display: block;
  font-size: 14px;
}
@media (max-width: 991px) {
  .styles__priceInfo___ptvk_ {
    padding: 0px;
  }
}
.styles__priceColumn___gVI1v {
  padding: 0 !important;
}
@media (min-width: 992px) {
  .styles__priceColumn___gVI1v {
    display: flex !important;
    align-items: flex-end !important;
    flex-direction: column !important;
  }
}
.styles__comment___YBd0j {
  color: #D9534F;
}
.styles__limitedQuantityMessage___uGnHX {
  color: #d9534f;
}
.styles__productSingle___m4q05 {
  width: 25%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0 !important;
}
.styles__productSingle___m4q05 .styles__productItemWrapper___U7iDV {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  flex-grow: 1;
}
.styles__productSingle___m4q05 .styles__productItemWrapper___U7iDV > .styles__productItem___P1IGq {
  width: 100%;
}
@media (min-width: 991px) {
  .styles__productSingle___m4q05 {
    height: auto !important;
  }
}
@media (max-width: 991px) {
  .styles__productSingle___m4q05 {
    width: 100%;
  }
}
.styles__productPair___x8jqc {
  width: 50%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0 !important;
}
.styles__productPair___x8jqc .styles__productItemWrapper___U7iDV {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  flex-grow: 1;
}
.styles__productPair___x8jqc .styles__productItemWrapper___U7iDV > .styles__productItem___P1IGq {
  width: 50%;
}
.styles__productPair___x8jqc .styles__orderInfoItem___IjBB2:last-child {
  border-left: 2px solid #fff;
}
@media (min-width: 991px) {
  .styles__productPair___x8jqc {
    height: auto !important;
  }
}
@media (max-width: 991px) {
  .styles__productPair___x8jqc {
    width: 100%;
  }
}
.styles__typeBadge___JpgHD {
  position: absolute;
  bottom: 10px;
  left: calc(50% - 80px);
}
.tyreType_winter svg path {
  filter: drop-shadow(0 0 1px #333);
  fill: #B2FFFF;
}
.tyreType_winter svg polygon:last-child {
  filter: drop-shadow(0 0 1px #333);
  fill: #B2FFFF;
}
.tyreType_2 svg path {
  filter: drop-shadow(0 0 1px #333);
  fill: #F9D857;
}
.styles__productItem___P1IGq {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.styles__noteWrapper___M3d1P {
  width: 100%;
  padding: 6px 20px 12px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
.styles__noteWrapper___M3d1P > div {
  flex-grow: 1;
}
.styles__buttonWrapper___fzFfW {
  width: 100%;
  padding: 0 20px 20px 20px;
}
.styles__productMainInfoWrapper___Winb5 {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.styles__productPosition___mowLu {
  position: absolute;
  top: -10px;
  z-index: 10;
  font-size: 12px !important;
  cursor: default !important;
}
.styles__productPosition___mowLu > span {
  padding: 2px 6px !important;
}
.styles__productPositionStaggered___eL1KI {
  position: absolute;
  top: -10px;
  z-index: 10;
  padding: 2px 8px !important;
  font-size: 12px !important;
  cursor: default !important;
  background-color: currentColor !important;
}
.styles__productPositionFront___ABjpr {
  left: auto;
  right: 0;
}
.styles__productPositionFront___ABjpr > span {
  color: #fff;
}
.styles__productPositionFront___ABjpr:after {
  content: '';
  position: absolute;
  top: 50%;
  left: -10px;
  transform: translateY(-50%);
  border-right: 10px solid currentColor;
  /* Color to match the arrow */
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.styles__productPositionRear___IERt0 {
  right: auto;
  left: 0;
}
.styles__productPositionRear___IERt0 > span {
  color: #fff;
}
.styles__productPositionRear___IERt0:after {
  content: '';
  position: absolute;
  top: 50%;
  right: -10px;
  transform: translateY(-50%);
  border-left: 10px solid currentColor;
  /* Color to match the arrow */
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.styles__productDimensions___tcWB8 {
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-self: center;
  align-self: flex-start;
  font-size: 0.9em;
  font-weight: bold;
}
.styles__productDescription___htuB8 .test-results {
  display: flex;
  justify-content: center;
}
.styles__productDescription___htuB8 .test-results .star-rating {
  margin-left: 0 !important;
}
.styles__productMainDetailsWrapper___QhGYd {
  padding: 20px 20px 0 20px;
}
.styles__productMainDetailsWrapper___QhGYd .styles__productProperties___BROUd {
  line-height: 14px;
}
.styles__productTitleWrapper___mZB8G {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}
.styles__productTitlePair___dazMn {
  display: table;
  table-layout: fixed;
  width: 100%;
  text-decoration: none;
  text-align: left;
}
.styles__productTitlePair___dazMn > span {
  display: table-row;
  font-size: 1.05em;
  font-weight: bolder;
}
.styles__productTitlePair___dazMn span span {
  display: table-cell;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.styles__productTitlePair___dazMn em {
  display: table-cell;
  font-size: 0.75em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-style: normal;
  font-weight: bold;
  box-sizing: border-box;
  padding: 0;
}
.styles__productDetailsWrapper___wD028 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 0 20px;
  flex-grow: 1;
}
.styles__productDetailsWrapper___wD028 > div {
  margin: 3px 0 !important;
}
.styles__orderInfo___puGgI {
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 12px 20px;
}
.styles__orderInfo___puGgI .styles__orderInfoItem___IjBB2 {
  position: relative;
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 991px) {
  .styles__orderInfo___puGgI .styles__orderInfoItem___IjBB2 {
    align-items: flex-start;
    flex-direction: column;
  }
}
.styles__orderInfo___puGgI .styles__orderInfoItem___IjBB2 .styles__quantityWrapper___yX5eF {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.styles__orderInfo___puGgI .styles__orderInfoItem___IjBB2 .styles__quantityWrapper___yX5eF > span:first-child {
  margin-right: 0.5em;
}
.styles__orderInfo___puGgI .styles__orderInfoItem___IjBB2 .styles__quantityWrapper___yX5eF > span:last-child {
  border: 1px solid #ccc;
  padding: 0;
}
.styles__orderInfo___puGgI .styles__orderInfoItem___IjBB2 .styles__quantityWrapper___yX5eF > span:last-child input {
  padding: 2px 2px 2px 6px;
  height: 1.65em;
}
.styles__orderInfo___puGgI .styles__orderInfoItemFront___E2Rie {
  padding: 0 20px 0 0;
}
.styles__orderInfo___puGgI .styles__orderInfoItemRear___KLvP0 {
  padding: 0 0 0 20px;
}
.styles__priceExtra___Eey8A {
  width: 100%;
  padding: 0 20px;
}
.styles__buttonPair___OgiGu {
  width: 100%;
  height: 40px;
  max-height: 40px;
}
.styles__buttonPair___OgiGu > span:first-child {
  padding-right: 6px;
}
@media (max-width: 991px) {
  .styles__buttonPair___OgiGu {
    width: 100%;
    height: 48px;
  }
}
.styles__campaign___qVQQv {
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 100%;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  padding: 2em 1em 1em 1em;
  flex-grow: 1;
  align-items: stretch;
  height: auto;
}
.styles__campaignLabel___Ik1d5 {
  width: 100%;
  line-height: 1.05em;
  font-size: 1.05em;
  font-weight: bold;
  text-align: center;
}
.styles__campaignLabel2___CTsao {
  flex-grow: 1;
}
.styles__campaignLabelWrapper___zq4ul {
  padding: 0.5em 1em;
  border-radius: 30px;
  background-color: color-mix(in srgb, currentColor, transparent 80%) !important;
}
.delivery {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.delivery .deliveryInfo {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 0 1em 0.5em 0;
}
.delivery .deliveryInfo .iconDelivery {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  width: 30px;
  height: 30px;
  margin-right: 0.5em;
  border-radius: 50%;
}
.delivery .deliveryInfo .deliveryText {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-weight: normal;
}
.delivery .deliveryInfo .deliveryText .deliveryLabel {
  font-weight: bold;
  color: #333333;
}
@media (max-width: 991px) {
  .delivery .deliveryInfo {
    align-items: flex-start;
    flex-direction: column;
  }
}
.delivery .orderBeforeInfo {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 0 1em 1em 0;
}
.delivery .orderBeforeInfo .iconOrderBefore {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  width: 30px;
  height: 30px;
  margin-right: 0.5em;
  border-radius: 50%;
}
.delivery .orderBeforeInfo .deliveryText {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-weight: normal;
}
.delivery .orderBeforeInfo .deliveryText .deliveryLabel {
  font-weight: bold;
  color: #333333;
}
@media (max-width: 991px) {
  .delivery .orderBeforeInfo {
    align-items: flex-start;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/components/Search/SearchResults/ProductsList/Product/styles.less"],"names":[],"mappings":"AAEA;EACE,mBAAA;AADF;AAIA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAFF;AAKA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AAHF;AAIE;EAAA;IACE,mBAAA;IACA,mBAAA;EADF;AACF;AAIA;EACE,iBAAA;EACA,gBAAA;AAFF;AAKA;EACE,gBAAA;AAHF;AAMA;EACE,aAAA;EACA,mBAAA;AAJF;AAOA;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AALF;AAQA;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,+BAAA;AANF;AAHA;EAWM,cAAA;AALN;AASA;EACE,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;AAPF;AAUA;EAEE,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AARF;AASE;EAAA;IACE,aAAA;EANF;AACF;AAOE;EAAA;IACE,sBAAA;IACA,gBAAA;IACA,mBAAA;EAJF;AACF;AAOA;EACE,aAAA;EACA,mBAAA;AALF;AAME;EAAA;IACE,6BAAA;IACA,uBAAA;EAHF;AACF;AAMA;EACE,6BAAA;AAJF;AAOA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,0BAAA;AALF;AAQA;EACE,WAAA;AANF;AAOE;EAAA;IAEE,gBAAA;IACA,WAAA;IACA,YAAA;EALF;AACF;AAQA;AALA;AAOE;EAAA;IACE,gBAAA;EAJF;AACF;AAQE;EAAA;IACE,qBAAA;EALF;AACF;AAQA;EACE,uBAAA;EACA,2BAAA;AANF;AASA;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAPF;AAQE;EAAA;IACE,aAAA;EALF;AACF;AAQA;EACE,iBAAA;EACA,WAAA;AANF;AAOE;EAAA;IACE,aAAA;EAJF;AACF;AAOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AALF;AACA;EAOI,eAAA;EACA,iBAAA;AALJ;AAHA;EAYI,cAAA;EACA,eAAA;AANJ;AASE;EAAA;IACE,YAAA;EANF;AACF;AAUA;EACE,qBAAA;AARF;AASE;EAAA;IACE,wBAAA;IACA,gCAAA;IACA,iCAAA;EANF;AACF;AASA;EACE,cAAA;AAPF;AAUA;EACE,cAAA;AARF;AAYA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AAVF;AAMA;EAOI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,YAAA;AAVJ;AAFA;EAeM,WAAA;AAVN;AAcE;EAAA;IACE,uBAAA;EAXF;AACF;AAaE;EAAA;IACE,WAAA;EAVF;AACF;AAaA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AAXF;AAOA;EAOI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,YAAA;AAXJ;AADA;EAeM,UAAA;AAXN;AAJA;EAoBI,2BAAA;AAbJ;AAgBE;EAAA;IACE,uBAAA;EAbF;AACF;AAeE;EAAA;IACE,WAAA;EAZF;AACF;AAeA;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;AAbF;AAgBA;EAGM,iCAAA;EACA,aAAA;AAhBN;AAYA;EAOM,iCAAA;EACA,aAAA;AAhBN;AAqBA;EAGM,iCAAA;EACA,aAAA;AArBN;AA0BA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AAxBF;AA2BA;EACE,WAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAzBF;AAmBA;EASI,YAAA;AAzBJ;AA6BA;EACE,WAAA;EACA,yBAAA;AA3BF;AA8BA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AA5BF;AA+BA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EAEA,0BAAA;EACA,0BAAA;AA9BF;AAiCA;EAEI,2BAAA;AAhCJ;AAoCA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yCAAA;AAlCF;AAqCA;EACE,UAAA;EACA,QAAA;AAnCF;AAiCA;EAUI,WAAA;AAxCJ;AA4CA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,qCAAA;EA1CA,6BAA6B;EA2C7B,kCAAA;EACA,qCAAA;AAzCF;AA4CA;EACE,WAAA;EACA,OAAA;AA1CF;AAwCA;EAUI,WAAA;AA/CJ;AAmDA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;EACA,oCAAA;EAjDA,6BAA6B;EAkD7B,kCAAA;EACA,qCAAA;AAhDF;AAmDA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AAjDF;AAoDA;EAEI,aAAA;EACA,uBAAA;AAnDJ;AAgDA;EAMM,yBAAA;AAnDN;AAwDA;EACE,yBAAA;AAtDF;AAqDA;EAII,iBAAA;AAtDJ;AA0DA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AAxDF;AA2DA;EACE,cAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;AAzDF;AAoDA;EAQI,kBAAA;EACA,iBAAA;EACA,mBAAA;AAzDJ;AA+CA;EAcI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA1DJ;AAyCA;EAqBI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;AA5DJ;AAgEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AA9DF;AAuDA;EAUI,wBAAA;AA9DJ;AAkEA;EACE,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;AAhEF;AAwDA;EAWI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAhEJ;AAkEI;EAAA;IACE,uBAAA;IACA,sBAAA;EA/DJ;AACF;AA0CA;EAyBM,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAhEN;AAoCA;EA+BQ,mBAAA;AAhER;AAiCA;EAmCQ,sBAAA;EACA,UAAA;AAjER;AA6BA;EAuCU,wBAAA;EACA,cAAA;AAjEV;AAyBA;EA+CI,mBAAA;AArEJ;AAsBA;EAmDI,mBAAA;AAtEJ;AA0EA;EACE,WAAA;EACA,eAAA;AAxEF;AA2EA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAzEF;AAsEA;EAMI,kBAAA;AAzEJ;AA4EE;EAAA;IACE,WAAA;IACA,YAAA;EAzEF;AACF;AA4EA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,wBAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;AA1EF;AA6EA;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AA3EF;AA8EA;EACE,YAAA;AA5EF;AA+EA;EACE,kBAAA;EACA,mBAAA;EACA,8EAAA;AA7EF;AAgFA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AA9EF;AA0EA;EAOI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AA9EJ;AAmEA;EAcM,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA9EN;AAyDA;EAyBM,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;AA/EN;AAkDA;EAgCQ,iBAAA;EACA,cAAA;AA/ER;AAmFI;EAAA;IACE,uBAAA;IACA,sBAAA;EAhFJ;AACF;AAwCA;EA4CI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAjFJ;AAiCA;EAmDM,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAjFN;AAuBA;EA8DM,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;AAlFN;AAgBA;EAqEQ,iBAAA;EACA,cAAA;AAlFR;AAsFI;EAAA;IACE,uBAAA;IACA,sBAAA;EAnFJ;AACF","sourcesContent":["@import '../../../../../../shared/variables.less';\n\n.marginBottom {\n  margin-bottom: 20px;\n}\n\n.inline {\n  display: flex;\n  font-size: 14px;\n  align-items: center;\n}\n\n.row {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  @media (min-width: 991px) {\n    flex-direction: row;\n    align-items: center;\n  }\n}\n\n.topItem {\n  padding-top: 10px;\n  min-height: 44px;\n}\n\n.testRatings {\n  min-height: 13px;\n}\n\n.flexIt {\n  display: flex;\n  align-items: center;\n}\n\n.img {\n  border: none;\n  margin-left: -5px;\n  width: 120px;\n  vertical-align: top;\n}\n\n.productThumbnail {\n  width: 100%;\n  margin: 0 auto;\n  padding: 10px 0;\n  text-align: center;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  box-sizing: border-box;\n  background: rgba(0,0,0,0.05);\n  > div {\n      margin: 0 auto;\n  }\n}\n\n.productBadge {\n  position: absolute;\n  bottom: 10px;\n  right: calc(50% - 60px);\n  z-index: 1;\n}\n\n.product {\n  composes: flexIt;\n  padding-right: 15px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  @media (min-width: 991px) {\n    height: 180px;\n  }\n  @media (max-width: 991px) {\n    flex-direction: column;\n    padding-right: 0;\n    padding-bottom: 0px;\n  }\n}\n\n.titleColumn {\n  display: flex;\n  align-items: center;\n  @media (max-width: 991px) {\n    border-bottom: 1px solid #ccc;\n    justify-content: center;\n  }\n}\n\n.titleWidth {\n  max-width: calc(100% - 120px);\n}\n\n.productTitle {\n  font-weight: 400;\n  font-size: 18px;\n  display: block;\n  text-overflow: ellipsis;\n  text-decoration: underline;\n}\n\n.smFull {\n  width: auto;\n  @media (max-width: @screen-sm-max) {\n    // margin-left: auto;\n    min-width: 270px;\n    width: 100%;\n    height: 48px;\n  }\n}\n\n.buttonGroup {\n  composes: smFull;\n  @media (min-width: @screen-md-min) {\n    margin-top: 20px;\n  }\n}\n\n.colFullSize {\n  @media (max-width: @screen-sm-max) {\n    padding: 0 !important;\n  }\n}\n\n.commentInput {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.quantityInCartSm {\n  text-align: right;\n  width: 100%;\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-bottom: 20px;\n  @media (min-width: @screen-md-min) {\n    display: none;\n  }\n}\n\n.quantityInCartMd {\n  text-align: right;\n  width: 100%;\n  @media (max-width: @screen-sm-max) {\n    display: none;\n  }\n}\n\n.priceInfo {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  white-space: nowrap;\n\n  .price {\n    font-size: 20px;\n    font-weight: bold;\n  }\n\n  .pricePcs {\n    display: block;\n    font-size: 14px;\n  }\n\n  @media (max-width: 991px) {\n    padding: 0px;\n  }\n}\n\n\n.priceColumn {\n  padding: 0 !important;\n  @media (min-width: @screen-md-min) {\n    display: flex !important;\n    align-items: flex-end !important;\n    flex-direction: column !important;\n  }\n}\n\n.comment {\n  color: @eon-text-color-red;\n}\n\n.limitedQuantityMessage {\n  color: @danger;\n}\n\n// NOTE: Front + Rear layout override\n.productSingle {\n  width: 25%;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0 !important;\n\n  .productItemWrapper {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: stretch;\n    justify-content: center;\n    flex-grow: 1;\n\n    > .productItem  {\n      width: 100%;\n    }\n  }\n\n  @media (min-width: 991px) {\n    height: auto !important;\n  }\n\n  @media (max-width: 991px) {\n    width: 100%;\n  }\n}\n\n.productPair {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0 !important;\n\n  .productItemWrapper {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: stretch;\n    justify-content: center;\n    flex-grow: 1;\n\n    > .productItem  {\n      width: 50%;\n    }\n  }\n\n  .orderInfoItem:last-child {\n    border-left: 2px solid #fff;\n  }\n\n  @media (min-width: 991px) {\n    height: auto !important;\n  }\n\n  @media (max-width: 991px) {\n    width: 100%;\n  }\n}\n\n.typeBadge {\n  position: absolute;\n  bottom: 10px;\n  left: calc(50% - 80px);\n}\n\n:global(.tyreType_winter) {\n  svg {\n    path {\n      filter: drop-shadow(0 0 1px #333);\n      fill: #B2FFFF;\n    }\n    polygon:last-child {\n      filter: drop-shadow(0 0 1px #333);\n      fill: #B2FFFF;\n    }\n  }\n}\n\n:global(.tyreType_2) {\n  svg {\n    path {\n      filter: drop-shadow(0 0 1px #333);\n      fill: #F9D857;\n    }\n  }\n}\n\n.productItem {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.noteWrapper {\n  width: 100%;\n  padding: 6px 20px 12px 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n\n  > div {\n    flex-grow: 1;\n  }\n}\n\n.buttonWrapper {\n  width: 100%;\n  padding: 0 20px 20px 20px;\n}\n\n.productMainInfoWrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.productPosition {\n  position: absolute;\n  top: -10px;\n  z-index: 10;\n\n  font-size: 12px !important;\n  cursor: default !important;\n}\n\n.productPosition {\n  > span {\n    padding: 2px 6px !important;\n  }\n}\n\n.productPositionStaggered {\n  position: absolute;\n  top: -10px;\n  z-index: 10;\n  padding: 2px 8px !important;\n  font-size: 12px !important;\n  cursor: default !important;\n  background-color: currentColor !important;\n}\n\n.productPositionFront {\n  left: auto;\n  right: 0;\n\n  // @media (max-width: 991px) {\n  //   left: 0;\n  //   right: auto;\n  //   border-radius: 12px !important;\n  // }\n  > span {\n    color: #fff;\n  }\n}\n\n.productPositionFront:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: -10px;\n  transform: translateY(-50%);\n  border-right: 10px solid currentColor; /* Color to match the arrow */\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.productPositionRear {\n  right: auto;\n  left: 0;\n\n  // @media (max-width: 991px) {\n  //   left: auto;\n  //   right: 0;\n  //   border-radius: 12px !important;\n  // }\n  > span {\n    color: #fff;\n  }\n}\n\n.productPositionRear:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: -10px;\n  transform: translateY(-50%);\n  border-left: 10px solid currentColor; /* Color to match the arrow */\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n}\n\n.productDimensions {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  justify-self: center;\n  align-self: flex-start;\n  font-size: 0.9em;\n  font-weight: bold;\n}\n\n.productDescription {\n  :global(.test-results) {\n    display: flex;\n    justify-content: center;\n\n    :global(.star-rating) {\n      margin-left: 0 !important;\n    }\n  }\n}\n\n.productMainDetailsWrapper {\n  padding: 20px 20px 0 20px;\n\n  .productProperties {\n    line-height: 14px;\n  }\n}\n\n.productTitleWrapper {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 8px;\n}\n\n.productTitlePair {\n  display: table;\n  table-layout: fixed;\n  width: 100%;\n  text-decoration: none;\n  text-align: left;\n\n  > span {\n    display: table-row;\n    font-size: 1.05em;\n    font-weight: bolder;\n  }\n\n  span span {\n    display: table-cell;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  em {\n    display: table-cell;\n    font-size: 0.75em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    // white-space: nowrap;\n    font-style: normal;\n    font-weight: bold;\n    box-sizing: border-box;\n    padding: 0;\n  }\n}\n\n.productDetailsWrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n  padding: 0 20px;\n  flex-grow: 1;\n\n  > div {\n    margin: 3px 0 !important;\n  }\n}\n\n.orderInfo {\n  border-left: none !important;\n  border-right: none !important;\n  border-bottom: none !important;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 20px 12px 20px;\n\n  .orderInfoItem {\n    position: relative;\n    width: 100%;\n    padding: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    @media (max-width: 991px) {\n      align-items: flex-start;\n      flex-direction: column;\n    }\n\n    .quantityWrapper {\n      // flex: 0 0 auto;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: center;\n\n      > span:first-child {\n        margin-right: 0.5em;\n      }\n\n      > span:last-child {\n        border: 1px solid #ccc;\n        padding: 0;\n\n        input {\n          padding: 2px 2px 2px 6px;\n          height: 1.65em;\n        }\n      }\n    }\n  }\n\n  .orderInfoItemFront {\n    padding: 0 20px 0 0;\n  }\n\n  .orderInfoItemRear {\n    padding: 0 0 0 20px;\n  }\n}\n\n.priceExtra {\n  width: 100%;\n  padding: 0 20px;\n}\n\n.buttonPair {\n  width: 100%;\n  height: 40px;\n  max-height: 40px;\n\n  > span:first-child {\n    padding-right: 6px;\n  }\n\n  @media (max-width: @screen-sm-max) {\n    width: 100%;\n    height: 48px;\n  }\n}\n\n.campaign {\n  display: flex;\n  flex-direction: column;\n  gap: 1em;\n  width: 100%;\n  border-top: none !important;\n  border-left: none !important;\n  border-right: none !important;\n  padding: 2em 1em 1em 1em;\n  flex-grow: 1;\n  align-items: stretch;\n  height: auto;\n}\n\n.campaignLabel {\n  width: 100%;\n  line-height: 1.05em;\n  font-size: 1.05em;\n  font-weight: bold;\n  text-align: center;\n}\n\n.campaignLabel2 {\n  flex-grow: 1;\n}\n\n.campaignLabelWrapper {\n  padding: 0.5em 1em;\n  border-radius: 30px;\n  background-color: color-mix(in srgb, currentColor, transparent 80%) !important;\n}\n\n:global(.delivery) {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n\n  :global(.deliveryInfo) {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    margin: 0 1em 0.5em 0;\n\n    :global(.iconDelivery) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: white;\n      width: 30px;\n      height: 30px;\n      margin-right: 0.5em;\n      border-radius: 50%;\n    }\n\n    :global(.deliveryText) {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n      font-weight: normal;\n\n      :global(.deliveryLabel) {\n        font-weight: bold;\n        color: @eon-text-color-light;\n      }\n    }\n\n    @media (max-width: 991px) {\n      align-items: flex-start;\n      flex-direction: column;\n    }\n  }\n\n  :global(.orderBeforeInfo) {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    margin: 0 1em 1em 0;\n\n    :global(.iconOrderBefore) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: white;\n      width: 30px;\n      height: 30px;\n      margin-right: 0.5em;\n      border-radius: 50%;\n    }\n\n    :global(.deliveryText) {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n      font-weight: normal;\n\n      :global(.deliveryLabel) {\n        font-weight: bold;\n        color: @eon-text-color-light;\n      }\n    }\n\n    @media (max-width: 991px) {\n      align-items: flex-start;\n      flex-direction: column;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marginBottom": `styles__marginBottom___lKRfS`,
	"inline": `styles__inline___pjfFK`,
	"row": `styles__row___qNIJU`,
	"topItem": `styles__topItem___FxQTR`,
	"testRatings": `styles__testRatings___nue5C`,
	"flexIt": `styles__flexIt___sd794`,
	"img": `styles__img___CDyjJ`,
	"productThumbnail": `styles__productThumbnail___VvdzD`,
	"productBadge": `styles__productBadge___lgPvN`,
	"product": `styles__product___sjClU styles__flexIt___sd794`,
	"titleColumn": `styles__titleColumn___QCNZ4`,
	"titleWidth": `styles__titleWidth___d6pM_`,
	"productTitle": `styles__productTitle___xjHWv`,
	"smFull": `styles__smFull___EyPmU`,
	"buttonGroup": `styles__buttonGroup___TU1jA styles__smFull___EyPmU`,
	"colFullSize": `styles__colFullSize___AvGIg`,
	"commentInput": `styles__commentInput___kfSL2`,
	"quantityInCartSm": `styles__quantityInCartSm___Yq6Ug`,
	"quantityInCartMd": `styles__quantityInCartMd___W6c9z`,
	"priceInfo": `styles__priceInfo___ptvk_`,
	"price": `styles__price___DDDaX`,
	"pricePcs": `styles__pricePcs___UakAO`,
	"priceColumn": `styles__priceColumn___gVI1v`,
	"comment": `styles__comment___YBd0j`,
	"limitedQuantityMessage": `styles__limitedQuantityMessage___uGnHX`,
	"productSingle": `styles__productSingle___m4q05`,
	"productItemWrapper": `styles__productItemWrapper___U7iDV`,
	"productItem": `styles__productItem___P1IGq`,
	"productPair": `styles__productPair___x8jqc`,
	"orderInfoItem": `styles__orderInfoItem___IjBB2`,
	"typeBadge": `styles__typeBadge___JpgHD`,
	"noteWrapper": `styles__noteWrapper___M3d1P`,
	"buttonWrapper": `styles__buttonWrapper___fzFfW`,
	"productMainInfoWrapper": `styles__productMainInfoWrapper___Winb5`,
	"productPosition": `styles__productPosition___mowLu`,
	"productPositionStaggered": `styles__productPositionStaggered___eL1KI`,
	"productPositionFront": `styles__productPositionFront___ABjpr`,
	"productPositionRear": `styles__productPositionRear___IERt0`,
	"productDimensions": `styles__productDimensions___tcWB8`,
	"productDescription": `styles__productDescription___htuB8`,
	"productMainDetailsWrapper": `styles__productMainDetailsWrapper___QhGYd`,
	"productProperties": `styles__productProperties___BROUd`,
	"productTitleWrapper": `styles__productTitleWrapper___mZB8G`,
	"productTitlePair": `styles__productTitlePair___dazMn`,
	"productDetailsWrapper": `styles__productDetailsWrapper___wD028`,
	"orderInfo": `styles__orderInfo___puGgI`,
	"quantityWrapper": `styles__quantityWrapper___yX5eF`,
	"orderInfoItemFront": `styles__orderInfoItemFront___E2Rie`,
	"orderInfoItemRear": `styles__orderInfoItemRear___KLvP0`,
	"priceExtra": `styles__priceExtra___Eey8A`,
	"buttonPair": `styles__buttonPair___OgiGu`,
	"campaign": `styles__campaign___qVQQv`,
	"campaignLabel": `styles__campaignLabel___Ik1d5`,
	"campaignLabel2": `styles__campaignLabel2___CTsao`,
	"campaignLabelWrapper": `styles__campaignLabelWrapper___zq4ul`
};
export default ___CSS_LOADER_EXPORT___;
